module.exports = __webpack_public_path__ + "static/media/w4.8ea40244.png";